import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { nanoid } from 'nanoid';
import { toast } from 'react-toastify';

//Servicios
import { UserService, ViniedoService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Profile from './Profile';

function ProfileContainer() {
    const { token, user, setUser, viniedos } = useGlobalContext();

    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [watchUserLogs, setWatchUserLogs] = useState(false);
    const [nroViñedoArray, setNroViñedoArray] = useState(
        viniedos.map((v) => {
            return { id: v.id, data: v.num };
        })
    );
    const [currentUser, setCurrentUser] = useState({});

    const {
        register,
        control,
        watch,
        reset,
        handleSubmit,
        setError,
        formState,
    } = useForm();

    useEffect(() => {
        setLoader(true);

        async function fetchCurrentUserData() {
            try {
                setLoader(true);

                if (parseInt(Params.id) === user.id) {
                    setCurrentUser(user);
                    user.clave = '';
                    reset(user);
                }

                if (parseInt(Params.id) !== user.id) {
                    const SelectedUser = await UserService.single({
                        token,
                        usuarioId: parseInt(Params.id),
                    });

                    if (SelectedUser) {
                        setCurrentUser(SelectedUser.data);
                        SelectedUser.data.clave = '';
                        reset(SelectedUser.data);

                        if (
                            user.tipo !== 3 ||
                            (user.id !== parseInt(Params.id) &&
                                SelectedUser.data.tipo !== 3)
                        ) {
                            const currentUserViniedos =
                                await ViniedoService.all({
                                    token,
                                    usuarioId: parseInt(Params.id),
                                });

                            if (currentUserViniedos) {
                                const nrosViniedos =
                                    currentUserViniedos.data.map((v) => {
                                        return { id: v.id, data: v.num };
                                    });
                                setNroViñedoArray(nrosViniedos);
                            }
                        }
                    }
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                if (err.response.data.codigo == 'VIN07') setNroViñedoArray([]);
                return err;
            }
        }

        fetchCurrentUserData();

        setLoader(false);
    }, [Params.id]);

    const onSubmit = async (data) => {
        // console.log(data);
        try {
            setLoader(true);

            delete data.confirmPassword;

            let viniedos = nroViñedoArray.map((v) => {
                return v.data;
            });

            const updateUser = await UserService.update({
                token,
                usuario: { ...data },
                viniedos,
            });

            if (updateUser) {
                if (user.id === parseInt(Params.id)) {
                    setUser({ ...user, ...data });
                    window.sessionStorage.setItem(
                        'user',
                        JSON.stringify({ ...user, ...data })
                    );
                }
                toast('Usuario Actualizado', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            toast('No se pudo actualizar usuario', { type: 'error' });
            setLoader(false);
            return err;
        }
    };

    const onAddBadge = (data) => {
        let array = [...nroViñedoArray];

        array.push({ id: nanoid(), data: data.nrosViñedos });

        setNroViñedoArray(array);
        document.querySelector('.input-badge').value = '';
    };

    const onBadgeDelete = (id) => {
        let array = [...nroViñedoArray];

        let filteredArray = array.filter((data) => data.id != id);

        setNroViñedoArray(filteredArray);
    };

    return loader ? (
        <Spinner />
    ) : (
        <>
            <Profile
                functions={{
                    register,
                    control,
                    watch,
                    handleSubmit,
                    setError,
                    formState,
                    onSubmit,
                    onAddBadge,
                    onBadgeDelete,
                    setWatchUserLogs,
                }}
                states={{ watchUserLogs, nroViñedoArray, currentUser }}
            />
        </>
    );
}

export default ProfileContainer;
